import { BaseService } from './BaseService';
import { FetchResult } from 'apollo-link';
import { ApolloQueryResult } from 'apollo-client';
import listCustomers from '@/graphql/queries/FetchShippers.gql';
import updateCustomer from '@/graphql/mutations/CustomerUpdate.gql';
import {
  PaginationInput,
  ShipperInput,
  fetchShippers,
  updateShipper
} from '@/types/graphql/schemaTypes';

class CustomerService extends BaseService {
  public listCustomers(
    customerArgs?: any,
    pagination?: PaginationInput | null
  ): Promise<ApolloQueryResult<fetchShippers>> {
    return this.client.query({
      query: listCustomers,
      variables: {
        pagination,
        shipperArgs: customerArgs || {}
      }
    });
  }

  public updateCustomer(customerArgs: ShipperInput):
    Promise<FetchResult<updateShipper>> {
    return this.client.mutate({
      mutation: updateCustomer,
      variables: {
        shipperArgs: customerArgs
      }
    }).then((result) => {
      return result;
    });
  }
}

export const customerService = new CustomerService();
